import React from 'react';
import img2 from '../../assets/img/img2.jpg';

import './Presentation.css';

const Presentation = () => {
  return (
    <div className="presentation-container">
        <div className="image-section">
            <img src={img2} alt="Imagen 2" />
        </div>
        <div className="separator"></div>
        <div className="text-section">
          <h2>¿EN QUE TE PODEMOS AYUDAR?</h2>
          <p>
            Nuestro enfoque se centra en brindar un servicio personalizado,
            adaptándose a las necesidades específicas de cada cliente, lo que
            nos permite construir relaciones de confianza y apoyo a largo plazo.
            Con un equipo de expertos altamente calificados, Poplavsky Group se
            compromete a ofrecer servicios de alta calidad y a ser un socio
            estratégico en el crecimiento y desarrollo de nuestros clientes en un
            entorno empresarial en constante evolución.
          </p>
        </div>
    </div>
  );
};

export default Presentation;
